








































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  FrameColor,
  UnframedFrameProperties,
  FramedFrameProperties,
  FrameStatus,
  Print

} from "../types/print";
import * as CartProvider from "../providers/CartProvider";
import { formatCurrency, isUSLocale } from "@/util/getCurrency";

interface colorDescriptions {
  id: FrameColor;
  label: string;
}

@Component
export default class LineItemFrameSelect extends Vue {
  @Prop({
    required: true
  })
  frameProperties!: UnframedFrameProperties | FramedFrameProperties;
  @Prop() currentFrameColor?: FrameColor;
  @Prop() productId!: string;
  @Prop() print?: Print;

  isUSLocale = isUSLocale
  formatCurrency = formatCurrency
  FrameColor = FrameColor;
  FrameStatus = FrameStatus;
  frameColor: FrameColor | undefined =
    this.currentFrameColor ||
    (this.print &&
      this.print.printProperties &&
      this.print.printProperties.frameColor) ||
    undefined;

  get showFrameSelect() {
    return (this.frameProperties.availableColors.length === 0 && this.frameProperties.frameStatus === "UNFRAMED")
  }

  get colors() {
    // fix to still show frame if the user previously selected a frame color which is now unavailable
    if (this.frameColor && !this.frameProperties.availableColors.includes(this.frameColor)) {
      this.frameProperties.availableColors.push(this.frameColor)
    }

    return this.frameProperties.availableColors
      .map(color => ({
        id: color,
        label: this.$t("frameColor." + color.toLowerCase())
      }))
      .filter(
        c =>
          c.id === this.frameColor ||
          this.frameProperties.frameStatus === FrameStatus.UNFRAMED
      );
  }

  get frameText() {
    const key = isUSLocale ? 'addFrameTextUs' : 'addFrameText'
    return this.$t(key, { price: formatCurrency(this.frameProperties.priceDifference) })
  }
  frame() {
    CartProvider.frame(this.productId, this.frameColor);
  }
  unframe() {
    CartProvider.unframe(this.productId);
  }
  colorChange(color) {
    if (this.frameProperties.frameStatus == FrameStatus.FRAMED) {
      this.unframe();
    } else {
      this.frameColor = color;
      this.frame();

    }
  }
}
